import {useParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ProjectForm} from 'src/app/projects/ProjectForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const EditProjectPage = () => {
  useSetDocumentTitle('Edit Project');
  const {id} = useParams();

  return (
    <ContentWrapper>
      {id !== undefined && <ProjectForm id={Number(id)} mode="edit" />}
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ProjectEdit(':id'),
  element: <EditProjectPage />,
  module: ModuleEnum.Projects,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default EditProjectPage;
